interface IProps {
  title: string;
  text: string;
  grow?: boolean;
  image?: string;
  button?: JSX.Element;
  className?: string;
}

export const Card = ({
  title,
  text,
  grow,
  image,
  button,
  className,
}: IProps) => {
  const isGrow = (isGrowable: boolean | undefined) => {
    return isGrowable ? "" : "h-fit";
  };

  return (
    <div
      className={`block min-w-sm max-w-sm md:max-w-lg rounded-lg shadow-md md:shadow-lg ${className} ${isGrow(
        grow
      )}`}
    >
      {image && (
        <img className={"rounded-t-lg"} src={image} alt={`${title} card`} />
      )}
      <div className={"flex flex-col p-6 gap-4"}>
        <h3
          className={
            "w-full text-balance md:text-2xl font-extrabold text-primary-500"
          }
        >
          {title}
        </h3>
        <p className={"md:text-lg text-primary-400"}>{text}</p>
        {button && button}
      </div>
    </div>
  );
};
